/**
 * ===== PDF Layout Configuration =====
 * Single source of truth for page geometry, typography and table layout.
 *
 * Column widths are expressed as PROPORTIONS (each array sums to 1.0) and are
 * converted to absolute millimetres at render time via `buildColumnStyles`, so
 * every table always fills the exact usable page width regardless of page size
 * or margin changes. This is what prevents the "table is too narrow on the
 * right" problem and keeps summary and table layout consistent.
 */
export const PDF_CONFIG = {
  page: {
    orientation: 'landscape' as const,
    unit: 'mm' as const,
    format: 'a4' as const,
    margin: 15,
  },
  font: {
    title: 18,
    metadata: 9,
    sectionHeader: 14,
    body: 11,
    tableHead: 11,
    tableBody: 10,
    // Denser sizes for wide tables (6+ columns) so content still fits.
    tableHeadDense: 10,
    tableBodyDense: 9,
  },
  spacing: {
    bodyLineHeight: 5, // mm advanced per line of body text
    afterSummary: 5, // mm gap after the summary block
    afterSection: 10, // mm gap after a table before the next section
  },
  table: {
    cellPadding: 3,
    lineColor: [200, 200, 200] as [number, number, number],
    lineWidth: 0.1,
  },
  // Each array MUST sum to 1.0 — proportions of the usable page width.
  columnProportions: {
    actionItems: [0.08, 0.62, 0.3],
    agreements: [0.07, 0.33, 0.25, 0.35],
    agreementContradictions: [0.06, 0.1, 0.15, 0.18, 0.27, 0.24],
    documentContradictions: [0.05, 0.09, 0.12, 0.13, 0.16, 0.15, 0.15, 0.15],
    transcript: [0.06, 0.13, 0.17, 0.64],
  },
};
